import React from "react"
import "./index.css"

const DashboardInput = ({
  type,
  label,
  icon,
  loading,
  error,
  className,
  select,
  textarea,
  children,
  button,
  fullWidth,
  ...props
}) => (
  <div className={"dashboard-input-container"}>
    {label && <label>{label}</label>}
    <div className={`dashboard-input-div${icon ? " icon" : ""}`}>
      {textarea ? (
        <div className={`input-layer${fullWidth ? " full-input" : ""}`}>
          <textarea
            className={`dashboard-input${className ? ` ${className}` : ""}`}
            {...props}
          />
        </div>
      ) : select ? (
        <div className={`select-container${fullWidth ? " fullWidth" : ""}`}>
          <select
            className={`dashboard-input custom-select${
              className ? ` ${className}` : ""
            }`}
            {...props}
          >
            {children}
          </select>
          <i className={`fas fa-angle-down fa-fw`} />
        </div>
      ) : (
        <div className={`input-layer${fullWidth ? " full-input" : ""}`}>
          <input
            className={`dashboard-input${className ? ` ${className}` : ""}`}
            type={type}
            {...props}
          />
          {button && (
            <button className={"side-button"} {...button}>
              {button.text}
            </button>
          )}
        </div>
      )}
      {icon && <div className={"dashboard-input-icon"}>{icon}</div>}
      {loading && (
        <div className={"loader"}>
          <i className={"fas fa-fw fa-spinner fa-spin"} />
        </div>
      )}
      {error && <p className={"error"}>{error}</p>}
    </div>
  </div>
)

export default DashboardInput



// WEBPACK FOOTER //
// ./src/components/dashboard-input/DashboardInput.js